import React from 'react'

import PropTypes from 'prop-types'

import './card.css'

const Card = (props) => {
  return (
    <figure className={`card-card card ${props.rootClassName} `}>
      <div className="card-header">
        <img alt="image" src={props.Icon} className="card-icon" />
        <h3 className="card-heading">{props.Title}</h3>
      </div>
      <p className="card-text">{props.Description}</p>
    </figure>
  )
}

Card.defaultProps = {
  Icon: '/playground_assets/group%201643%201.svg',
  Title: 'High-impact business services',
  rootClassName: '',
  Description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
}

Card.propTypes = {
  Icon: PropTypes.string,
  Title: PropTypes.string,
  rootClassName: PropTypes.string,
  Description: PropTypes.string,
}

export default Card
